import React, { lazy, useEffect } from 'react';
import AppShell from 'shared/containers/AppShell';
import AnswersBySectionProvider from 'shared/providers/AnswersBySectionProvider';
const AppBody = lazy(() => import('./AppBody'));

const onScroll = () => {
  if (window.location.pathname.includes('/donor/home')) {
    const top = window.pageYOffset;
    const hFiltersRoot = document.getElementById('h-filters-root');
    const hFiltersTitle = document.getElementById('h-filters-title');
    const hFiltersLogo = document.getElementById('h-filters-logo');
    const hFiltersMore = document.getElementById('h-filters-more');
    const hFiltersExpand = document.getElementById('h-filters-expand');
    const hFiltersAdd = document.getElementById('h-filters-add');
    const hTableRoot = document.getElementById('h-table-root');
    const hTableHeaderCell = document.getElementById('h-table-headercell');
    const hTableHeaderCellB = document.getElementById('h-table-headercell-b');
    const moreIsVisible = !!document.getElementById('h-more');

    if (top > 0) {
      if (hFiltersRoot) hFiltersRoot.classList.add('minified');
      if (hFiltersTitle) hFiltersTitle.classList.add('minified');
      if (hFiltersLogo) hFiltersLogo.classList.add('minified');
      if (hFiltersMore) hFiltersMore.classList.add('minified');
      if (hFiltersExpand) hFiltersExpand.classList.add('minified');
      if (hFiltersAdd) hFiltersAdd.classList.add('minified');
      if (hTableRoot) hTableRoot.classList.add('minified');
      if (hTableRoot && moreIsVisible)
        hTableRoot.classList.add('minified-more');
      if (hTableHeaderCell) hTableHeaderCell.classList.add('minified');
      if (hTableHeaderCellB) hTableHeaderCellB.classList.add('minified');
    } else {
      if (hFiltersRoot) hFiltersRoot.classList.remove('minified');
      if (hFiltersTitle) hFiltersTitle.classList.remove('minified');
      if (hFiltersLogo) hFiltersLogo.classList.remove('minified');
      if (hFiltersMore) hFiltersMore.classList.remove('minified');
      if (hFiltersExpand) hFiltersExpand.classList.remove('minified');
      if (hFiltersAdd) hFiltersAdd.classList.remove('minified');
      if (hTableRoot) hTableRoot.classList.remove('minified');
      if (hTableRoot) hTableRoot.classList.remove('minified-more');
      if (hTableHeaderCell) hTableHeaderCell.classList.remove('minified');
      if (hTableHeaderCellB) hTableHeaderCellB.classList.remove('minified');
    }
  }
};

window.addEventListener('scroll', onScroll);

const App: React.FC = () => {
  useEffect(() => {
    if (!window.location.origin.includes('app.trueimpact.com')) return;
    const s = document.createElement('script');
    s.async = true;
    s.id = 'external';
    s.crossOrigin = 'anonymous';
    s.src = 'https://cdn.lrkt-in.com/LogRocket.min.js';
    s.onload = () => {
      window.LogRocket?.init('wkxklb/true-impact');
    };
    document.head.appendChild(s);
    return () => {
      document.head.removeChild(s);
    };
  }, []);

  return (
    <AppShell>
      <AnswersBySectionProvider>
        <AppBody />
      </AnswersBySectionProvider>
    </AppShell>
  );
};

export default App;
